import PropTypes, { node } from 'prop-types'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

import PacingLayout from './PacingLayout'
import {
  handlePacingUpload,
  onFileChange,
} from '../../../redux/css-admin/pacing/operations'

const PacingContainer = props => {
  const {
    error,
    file,
    fileName,
    handlePacingUpload,
    isLoading,
    onFileChange,
    uploadResults,
  } = props || {}

  const createUploadResultRows = () => {
    if (!uploadResults) return null
    const { pacingDates: uploadPacingResults, errors } = uploadResults || {}

    const formattedUploadResults = uploadPacingResults.flatMap(pacingResult =>
      pacingResult.pacingDates.map(pacingEntry => ({
        siteId: pacingResult.siteId,
        siteName: pacingResult.siteName,
        nodeFriendlyName: pacingEntry.nodeFriendlyName,
        startDate: new Date(pacingEntry.startDate).toLocaleDateString() || '',
      })),
    )

    if (errors.length > 0) {
      errors.forEach(error => {
        formattedUploadResults.unshift({
          siteId: error.siteId,
          rowNumber: error.rowNumber,
          error: error.error,
        })
      })
    }
    return formattedUploadResults
  }

  return (
    <PacingLayout
      file={file}
      fileName={fileName}
      formattedResults={createUploadResultRows()}
      handlePacingUpload={handlePacingUpload}
      isLoading={isLoading}
      onFileChange={onFileChange}
    />
  )
}

const mapStateToProps = ({ pacingManager }) => ({
  ...pacingManager,
})

const mapDispatchToProps = {
  handlePacingUpload,
  onFileChange,
}

PacingContainer.propTypes = {
  error: PropTypes.string,
  file: PropTypes.object,
  fileName: PropTypes.string,
  handlePacingUpload: PropTypes.func,
  isLoading: PropTypes.bool,
  onFileChange: PropTypes.func,
  uploadResults: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(PacingContainer)



// WEBPACK FOOTER //
// ./src/containers/css-admin/pacing/PacingContainer.js